import { Injectable } from '@angular/core';
import {ConfigurationDataProvider} from '../configuration-data-provider';
import {SharedDataProvider} from '../shared-data-provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BinType} from '../dto/bin-type';

@Injectable()
export class BinTypeProvider {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  private getAuthHeader() : any {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-pePeLo-Auth': JSON.stringify(this.shared.getTokenAuthData())
    });
    return headers;
  }

  constructor(public http: HttpClient, private config : ConfigurationDataProvider, private shared: SharedDataProvider) {
  }

  /**
   * List all bintypes which belong to loggedin user.
   */
  public list() {
    return this.http.get(this.config.bintypeURL+"list", {headers: this.getAuthHeader()});
  }

  public save(bintype : BinType) {
    console.log('Push bintype to insert method of service.');
    bintype.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bintype));
    return this.http.post(this.config.bintypeURL+"new", JSON.stringify(bintype), {headers: this.headers});
  }

  public update(bintype : BinType) {
    console.log('Push bintype to update method of service.');
    bintype.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bintype));
    return this.http.put(this.config.bintypeURL+"id/"+bintype.id, JSON.stringify(bintype), {headers: this.headers});
  }

  public qryBinType(id : number) {
    return this.http.post(this.config.bintypeURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete bintype '+ id);
    return this.http.post(this.config.bintypeURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// ./src/providers/bin-type/bin-type.ts